import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
import { getAvatarJwt as loadAvatar, setAvatarJwt as saveAvatar } from "../utils/dwclient/dwclientutils";
import { DwMpcWalletBackendProviderContext } from "../mpcwalletprovider/DwMpcWalletBackendProvider";
import { createEmptyLogsAndVars, dwReportError, recordVariable, } from "../utils/diagnostics/clientErrors";
import { WalletProviderContext } from "../walletprovider/WalletProvider";
import { loadJwt } from "../utils/dwclient/localstorage/jwtStorage";
export const AvatarProviderContext = createContext({
    getAvatar: (provider) => Promise.resolve(undefined),
    getAvatarAsBase64: (provider) => Promise.resolve(undefined),
    setAvatar: (provider, file) => { },
    clearCachedAvatar: () => { },
});
export const AvatarProvider = ({ children }) => {
    const [providerForCachedAvatar, setProviderForCachedAvatar] = useState(null);
    const [cachedAvatar, setCachedAvatar] = useState();
    const { storageProps } = useContext(DwMpcWalletBackendProviderContext);
    const { selectedAccount } = useContext(WalletProviderContext);
    const toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });
    async function getAvatarAsBase64(provider) {
        const avatarFile = await getAvatar(provider);
        if (avatarFile === undefined) {
            return undefined;
        }
        return await toBase64(avatarFile);
    }
    async function getAvatar(provider) {
        //console.log("cachedAvatar", cachedAvatar);
        const logsAndVars = createEmptyLogsAndVars("AvatarProvider:getAvatar");
        recordVariable(logsAndVars, "cachedAvatar", cachedAvatar);
        if (cachedAvatar !== undefined && providerForCachedAvatar === provider) {
            //console.log("AvatarProvider returning cached avatar", provider.host, provider.path);
            return cachedAvatar;
        }
        try {
            //console.log("AvatarProvider loading avatar from backend");
            const jwt = await loadJwt();
            if (jwt === null) {
                return undefined;
            }
            const receivedAvatar = await loadAvatar(provider, jwt);
            recordVariable(logsAndVars, "receivedAvatar", receivedAvatar);
            //console.log(typeof receivedAvatar, receivedAvatar);
            setCachedAvatar(receivedAvatar);
            setProviderForCachedAvatar(provider);
            return receivedAvatar;
        }
        catch (error) {
            if (!error.message.startsWith("Parameters for requesting avatar are not (yet) available")) {
                dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
            }
            return undefined;
        }
    }
    async function setAvatar(provider, file) {
        const jwt = await loadJwt();
        if (jwt !== null) {
            await saveAvatar(provider, jwt, file);
            setCachedAvatar(file);
            setProviderForCachedAvatar(provider);
        }
    }
    function clearCachedAvatar() {
        setCachedAvatar(undefined);
        setProviderForCachedAvatar(null);
    }
    const contextValue = {
        getAvatar,
        getAvatarAsBase64,
        setAvatar,
        clearCachedAvatar,
    };
    return _jsx(AvatarProviderContext.Provider, { value: contextValue, children: children });
};
